import { Request, RequestStatus } from 'lib/generated/graphql';
import { DateTime } from 'luxon';
import Avatar from 'src/shared-components/Avatar';

const DEFAULT_USER_AVATAR = process.env.DEFAULT_USER_AVATAR || '';

const RequestStatusHeader = ({ request }: { request: Request }) => {
  const StatusTag = () => {
    switch (request.status) {
      case RequestStatus.PendingReview:
        return (
          <>
            <span className="px-5 py-1 bg-[#FFF8E7] w-fit rounded-6xl mb-4">⏳️ Pending Community Approval</span>
          </>
        );
      case RequestStatus.ClarificationNeeded:
        return (
          <div className="flex flex-row gap-x-3 items-center mb-4">
            <span className="px-5 py-1 bg-[#FFF8E7] w-fit rounded-6xl ">👋️ Clarification Needed</span>
            <span className="text-[#797979] text-sm">
              Status updated {DateTime.fromISO(request.updatedAt).toRelative()}
            </span>
          </div>
        );
      case RequestStatus.Denied:
        return (
          <>
            <span className="px-5 py-1 bg-[#FFF2F2] w-fit rounded-6xl mb-4">❗️ Denied</span>
          </>
        );
      default:
        return null;
    }
  };

  const Content = () => {
    if (request.partnerNotes) {
      return (
        <div className="flex flex-row gap-x-4">
          <div>
            <Avatar image={request.partner.photoUrl || DEFAULT_USER_AVATAR} size="xs" roundness="md" />
          </div>

          <p className="text-[#151515] text-sm">{request.partnerNotes}</p>
        </div>
      );
    } else if (request.status === RequestStatus.PendingReview) {
      return (
        <p className="text-[#151515] text-sm">
          We&apos;re reviewing your request and will get back to you with your first teammate in 48 hours or less. There is an approval process
          because we&apos;re experiencing a high volume of requests and only accepting a subset to access Huddle teams.
        </p>
      );
    }
    return null;
  };

  return (
    <div className="bg-white flex flex-col  p-6 rounded-tl-xl rounded-tr-xl drop-shadow">
      <StatusTag />
      <Content />
    </div>
  );
};

export default RequestStatusHeader;
